import { analyticsService } from '~/services/business/analytics';
import { billingService } from '~/services/business/billing';
import { companyService } from '~/services/business/company';
import { consolidationService } from '~/services/business/consolidation';
import { departmentsService } from '~/services/business/departments';
import { employeesService } from '~/services/business/employees';
import { partnerService } from '~/services/business/partner';
import { reportsService } from '~/services/business/reports';
import { rolesService } from '~/services/business/roles';

export type { DashboardExposureCategory, DashboardExposureSplitSide, DashboardExposureSummary } from '~/types/business';

// The one published front door for business API calls. Each domain service in
// `~/services/business/*` owns its own endpoints; this object composes them so
// callers have a single import and a flat method surface.
export const businessService = {
    ...companyService,
    ...departmentsService,
    ...employeesService,
    ...rolesService,
    ...analyticsService,
    ...reportsService,
    ...billingService,
    ...consolidationService,
    ...partnerService,
};
